import React from "react";

import { useFormikContext } from "formik";
import { useLocStore } from "../../localization";
import { LocContext } from "../../localization/LocContext";
import { CvpButton, CvpButtonProps } from "./CvpButton";

interface CvpFormButtonProps extends CvpButtonProps {
  save?: boolean;
  send?: boolean;
  cancel?: boolean;
  delete?: boolean;
}

export const CvpFormButton = (props: CvpFormButtonProps) => {
  const { save, ...rest } = props;

  const L = useLocStore(LocContext.GENERAL);

  const btnLabel = save ? L.id("b4e41f387313").loc("Lagre") : "";

  const btnIcon = save ? "pi pi-save" : undefined;

  const formik = useFormikContext();

  return (
    <CvpButton
      label={btnLabel}
      type="submit"
      icon={btnIcon}
      iconPos="right"
      disabled={formik.isSubmitting}
      {...rest}
    />
  );
};
